import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-2xl font-extrabold font-display mb-6 tracking-tight">
              ALLCHINABUY
              <br />
              SPREADSHEET<span className="text-accent-500">.SBS</span>
            </h3>
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-xs">
              The largest independent AllChinaBuy Spreadsheet resource. Discover trusted products, verified sellers, and updated buying guides.
            </p>
            <div className="flex items-center gap-3">
              {["ri-twitter-x-line", "ri-reddit-line", "ri-discord-line", "ri-telegram-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:border-accent-400 hover:text-accent-400 transition-colors duration-200"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-white/50 mb-4">
              Quick Links
            </h4>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="block text-sm text-white/70 hover:text-accent-400 transition-colors duration-200"
            >
              AllChinaBuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="block text-sm text-white/70 hover:text-accent-400 transition-colors duration-200"
            >
              Buy It Now
            </a>
            <Link
              to="/best-allchinabuy-spreadsheet-guide"
              className="block text-sm text-white/70 hover:text-accent-400 transition-colors duration-200"
            >
              Buying Guide
            </Link>
            <Link
              to="/"
              className="block text-sm text-white/70 hover:text-accent-400 transition-colors duration-200"
            >
              Home
            </Link>
          </div>

          <div className="space-y-4">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-white/50 mb-4">
              Resources
            </h4>
            <p className="text-sm text-white/60 leading-relaxed">
              Content reviewed and updated regularly. Independent editorial standards. Transparency and user-focused recommendations.
            </p>
            <p className="text-sm text-white/60 leading-relaxed">
              All external links open on kaspreadsheet.com — your trusted source for curated product lists.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} AllChinaBuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200">
              Terms of Service
            </a>
            <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}